module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Buckten-b7e721b835e19260f6c120e145e3b362.svg";